import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="text-center notFound">
            <h1><span className="text-color">404</span>Not Found</h1>
            <p>The page you are looking for might have been removed or temporarily unavailable.</p>
            <a href="">Go back to home</a>
        </div>
    );
};

export default NotFound;
